import { MSText } from "../text/text.js";
import { MSPopUpWindow } from "../popup_window/popup_window.js";
import i18next from "i18next";
/**
 * @class MSNumericUpDown
 * @extends MSText
 * @classdesc Инкремент
 * */
export class MSNumericUpDown extends MSText {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "minvalue",
            "value",
            "maxvalue",
            "incrementstep",
            "isreadonly",
            "allownull",
            "showbuttons",
            "restrictmanualinput",
            "notsendbackwardconnection",
            "maxdecimalplaces",
            "tooltip",
            "instantdataretrieval",
            "disablemousewheel",
            "focushandling",
            "showmeasurement",
            "unitofmeasurement",
        ]);
    }
    constructor() {
        super();
        this._lockLink =
            this.getAttribute("notsendbackwardconnection") !== "false";
        this.style.display = "flex";
        this.style.overflow = "hidden";
        this.style.boxSizing = "border-box";
        this.shadowRoot.innerHTML = `
            <svg id="decr" style="width:1em; height:1em; border-right: 1px solid; cursor: pointer;" viewBox="0 0 24 24">
                <path d="M21 11V13H3V11H21Z" fill="#1B1A1A"/>
            </svg>
            <div style="flex: 1; display: flex; align-items: center; overflow: hidden;">
                <input id="input" style="width: 100%; height: 100%; padding: 0; background-color: transparent; border: none; text-align: center; font-size: 12px; font-family: Tahoma;">
                <div id="unitContainer" style="display: none; width: 60%; text-align: center; font-size: 12px; font-family: Tahoma; white-space: nowrap;"></div>
            </div>
            <svg id="incr" style="width:1em; height:1em; border-left: 1px solid; cursor: pointer;" viewBox="0 0 24 24">
                <path d="M12.9 11.1H21V12.9H12.9V21H11.1V12.9H3V11.1H11.1V3H12.9V11.1Z" fill="#1B1A1A"/>
            </svg>
        `;
        this._text = this.shadowRoot.querySelector("input");
        this._unitContainer = this.shadowRoot.getElementById("unitContainer");
        this._decr = this.shadowRoot.getElementById("decr");
        this._incr = this.shadowRoot.getElementById("incr");
        this._incrementstep = 1;
        this._maxdecimalplaces = 0;
        this.standartTooltip = i18next.t('numericupdown_tooltip');
        this.standartTooltipWithoutMin = i18next.t('numericupdown_tooltip_without_min');
        this.standartTooltipWithoutMax = i18next.t('numericupdown_tooltip_without_max');
        this.tooltip = this.standartTooltip;
        this.focusAndClickHandler = () => {
            this.handleFocus();
        }
        this._text.addEventListener('focus', this.focusAndClickHandler)
        this._text.addEventListener('click', this.focusAndClickHandler)
        this._text.addEventListener('keydown', this._keydownHandler)

        this._decr.onclick = (e) => {
            e.preventDefault();
            if (this._isreadonly) {
                return;
            }
            const cur = Number(this._text.value);
            let it = Math.max(
                this._decimalCount(cur),
                this._decimalCount(this._incrementstep)
            );
            if (it == 0) {
                it = 1;
            } else {
                it = Math.pow(10, it);
            }
            if (!isNaN(cur)) {
                const sum = (cur * it - this._incrementstep * it) / it;
                const val = this._minValidator(sum);
                this.SetParameter(
                    "value",
                    val > this.maxvalue ? this.maxvalue : val,
                    false,
                    null,
                    null,
                    "",
                    {
                        forced: true,
                    }
                );
            }
        };

        this._incr.onclick = e => {
            e.preventDefault();
            if (this._isreadonly) {
                return;
            }
            const cur = Number(this._text.value);
            let it = Math.max(
                this._decimalCount(cur),
                this._decimalCount(this._incrementstep)
            );
            if (it == 0) {
                it = 1;
            } else {
                it = Math.pow(10, it);
            }
            if (!isNaN(cur)) {
                const sum = (cur * it + this._incrementstep * it) / it;
                const val = this._maxValidator(sum);
                this.SetParameter(
                    "value",
                    val < this.minvalue ? this.minvalue : val,
                    false,
                    null,
                    null,
                    "",
                    {
                        forced: true,
                    }
                );
            }
        };

        this._text.onpaste = e => {
            e.stopPropagation();
            e.preventDefault();
            if (this._isreadonly) {
                return;
            }

            const clipboardData = e.clipboardData || window.clipboardData;
            const pastedData = Number(clipboardData.getData("Text"));
            if (isNaN(pastedData)) return;
            const start = e.target.selectionStart;
            const end = e.target.selectionEnd;

            const value =
                this._text.value.substr(0, start) +
                pastedData +
                this._text.value.substr(end);
            if (isNaN(value)) {
                return;
            }
            this.SetParameter(
                "value",
                this._minValidator(this._maxValidator(+value)),
                false,
                null,
                null,
                "",
                {
                    forced: true,
                }
            );
        };

        this._text.onchange = e => {
            e.preventDefault();
            if (this._isreadonly) {
                return;
            }
            this.updateValue();
        };

        this.inputListener = () => this.onInput();
        this._text.addEventListener('input', this.inputListener);

        this._setInputFilter(this._text);

        this._updateWheelBind = e => {
            e.preventDefault();
            if (this._isreadonly || !this.isenabled || this._maskElement || this.disablemousewheel) {
                return;
            }
            const delta = e.wheelDelta || -e.deltaY;
            let val;
            if (delta > 0) {
                const validatedVal = this._maxValidator(+this._text.value + this._incrementstep);
                val = validatedVal < this.minvalue ? this.minvalue : validatedVal;
            } else {
                const validatedVal = this._minValidator(+this._text.value - this._incrementstep);
                val = validatedVal > this.maxvalue ? this.maxvalue : validatedVal;
            }

            this.SetParameter("value", val, false, null, null, "", {
                forced: true,
            });
            return false;
        };

        const mousewheelevt = /Firefox/i.test(navigator.userAgent)
            ? "wheel"
            : "mousewheel";
        this.addEventListener(mousewheelevt, this._updateWheelBind);

        //this.setBaseParams();
        this._minvalue = this.getAttribute("minvalue")
            ? this.getAttribute("minvalue")
            : 0;
        this._maxvalue = this.getAttribute("maxvalue")
            ? this.getAttribute("maxvalue")
            : 100;
        this.updateTooltip();

        if (!this.getAttribute("value")) this.value = 50;
        this._showbuttons = true;
        //proto text
        this.textcolor = "BLACK";
        this.borderthickness = 1;
        this.backgroundcolor = "rgb(208,208,208)";
    }

    _keydownHandler = (e) => {
        if (e.key === "Enter") {
            requestAnimationFrame(() => { // blur отменяет отображение запрещающей модалки(если она будет), нужно дать js время отренерить модалку
                this._text.blur();
            })
        } else if (e.key === "Escape") {
            this._text.value = this._initialValue;
            this._text.blur();
        }
    }

    setPopup() {
        const infoPopup = new MSPopUpWindow();
        infoPopup.resize = false;
        infoPopup.minimized = false;
        infoPopup.closable = false;
        const startDescription = `${i18next.t('from_lower')} ${this.minvalue}`
        const endDescription = `${i18next.t('to_lower')} ${this.maxvalue}`
        const description = `${i18next.t('numericupdown_popup_description_start')} ${this.minvalue !== -Infinity ? startDescription : ""} ${this.maxvalue !== Infinity ? endDescription : ""}`
        infoPopup.title = i18next.t('warning');
        infoPopup.innerHTML = `<div style="display:flex; flex-direction: column; align-items: flex-end; padding: 10px;">
               <p style="padding: 20px 30px 30px 30px;">${description}</p>
               <button ok id="agree" style="border: none; background: #2F66C0; color: #fff; border-radius: 4px; padding: 6px 10px; cursor: pointer;">Ок</button>
            </div>
            `;
        document.body.appendChild(infoPopup)._upWindow();

        infoPopup.querySelector("#agree").onclick = e => {
            infoPopup.close()
        };
        infoPopup.default = infoPopup.querySelector("[ok]").onclick;
    }

    updateTooltip() {
        if (this.tooltip) {
            let newToolTip = this.tooltip
            const minVal = this.minvalue != null ? this.minvalue : 0;
            const maxVal = this.maxvalue != null ? this.maxvalue : 100;
            newToolTip = newToolTip.replace(/{Минимум}/g, minVal);
            newToolTip = newToolTip.replace(/{Min}/g, minVal);
            newToolTip = newToolTip.replace(/{Максимум}/g, maxVal);
            newToolTip = newToolTip.replace(/{Max}/g, maxVal);
        this.dataset.tooltip = newToolTip;
        } else {
            this.dataset.tooltip = '';
        }
    }

    _updateUnitOfMeasurementDisplay() {
        if(!this._unitContainer) return;
        if (this._showmeasurement) {
            this._unitContainer.style.display = 'flex';
            this._unitContainer.textContent = this._unitofmeasurement || '';
        } else {
            this._unitContainer.style.display = 'none';
        }
    }
    get unitofmeasurement() {
        return this._unitofmeasurement;
    }

    set unitofmeasurement(value) {
        this._unitofmeasurement = value;
        this._updateUnitOfMeasurementDisplay();
    }

    get showmeasurement() {
        return this._showmeasurement;
    }

    set showmeasurement(value) {
        this._showmeasurement = this._toBool(value);
        this._updateUnitOfMeasurementDisplay();
    }

    get notsendbackwardconnection() {
        return this._lockLink;
    }
    set notsendbackwardconnection(value) {
        this._lockLink = this._toBool(value);
    }

    get disablemousewheel() {
        return this._disablemousewheel ?? false;
    }

    set disablemousewheel(value) {
        this._disablemousewheel = this._toBool(value);
    }

    get focushandling() {
        return this._focushandling;
    }

    set focushandling(value) {
        this._focushandling = value;
    }

    unitContainerStyles() {
        requestAnimationFrame(() => {
            if(!this._unitContainer) return;
            this._unitContainer.style.color = this._text.style.color;
            this._unitContainer.style.fontSize = this._text.style.fontSize;
            this._unitContainer.style.fontFamily = this._text.style.fontFamily;
            this._unitContainer.style.textDecoration = this._text.style.textDecoration;
            this._unitContainer.style.fontStyle = this._text.style.fontStyle;
            this._unitContainer.style.fontWeight = this._text.style.fontWeight;
        })
    }

    handleFocus() {
        if (this._maskElement) {
            this.blur();
            return;
        }

        this._initialValue = this._text.value;
        switch (+this._focushandling) {
            case 1:
                this._text.select();
                break;
            case 2:
                this._text.setSelectionRange(0, 0);
                break;
            case 3:
                this._text.setSelectionRange(this._text.value.length, this._text.value.length);
                break;
            default:
                break;
        }
    }

    _minValidator(val) {
        if (this._isNumeric(this._minvalue)) {
            if (val < this._minvalue) {
                this.setPopup();
                return this.value
            } else {
                return val
            }
        }
        return val;
    }

    _maxValidator(val) {
        if (this._isNumeric(this._maxvalue)) {
            if (val > this._maxvalue) {
                this.setPopup();
                return this.value
            } else {
                return val
            }
        }
        return val;
    }

    get allownull() {
        return this._allownull;
    }
    set allownull(value) {
        this._allownull = this._toBool(value);
    }
    /**
     * Запрет ручного ввода
     * @type {bool}
     */
    get restrictmanualinput() {
        return this._restrictmanualinput || false;
    }
    set restrictmanualinput(value) {
        this._restrictmanualinput = this._toBool(value);
        if (this._restrictmanualinput) {
            this._text.setAttribute("readonly", "");
        } else {
            this._text.removeAttribute("readonly");
        }
    }
    /**
     * Горизонтальное выравнивание
     * @type {enum}
     */
    get texthorizontalalign() {
        return this._horizontalalign;
    }
    set texthorizontalalign(value) {
        this._horizontalalign = value;
        this._text.style.textAlign = window._enums.AlignText[value];
    }

    get textcolor() {
        return this._text.style.color;
    }
    set textcolor(value) {
        this._text.style.color = this.tryToGetUserColor(value);
        this.unitContainerStyles();
    }
    /**
     * Минимум
     * @type {number}
     */
    get minvalue() {
        return this._minvalue;
    }
    set minvalue(value) {
        const tmp = value == Infinity || value == -Infinity ? +value : this._adjustValue(+value)
        if(-Infinity === tmp && !this.anotherTooltip){
            this.tooltip = this.standartTooltipWithoutMin
        }
        if (!isNaN(tmp)) {
            this._minvalue = tmp;
            this.updateTooltip()
        }
    }
    /**
     * Максимум
     * @type {number}
     */
    get maxvalue() {
        return this._maxvalue;
    }
    set maxvalue(value) {
        const tmp = value == Infinity || value == -Infinity ? +value : this._adjustValue(+value)
        if(Infinity === tmp && !this.anotherTooltip){
            this.tooltip = this.standartTooltipWithoutMax
        }
        if (!isNaN(tmp)) {
            this._maxvalue = tmp;
            this.updateTooltip()
        }
    }

    /**
     * Текст всплывающей подсказки
     * @type {string}
     */
    get tooltip() {
        return super.tooltip;
    }
    set tooltip(value) {
        if(!(this.standartTooltip === value || this.standartTooltipWithoutMin === value || this.standartTooltipWithoutMax === value)){
            this.anotherTooltip = true
        }
        super.tooltip = value;
        this.updateTooltip();
    }

    /**
     * Значение
     * @type {number}
     */
    get value() {
        return this._value;
    }
    set value(value) {
        if (!this._isNumeric(value)) {
            if (this.allownull) {
                this._value = null;
                this._originValue = null;
                this._text.value = "";
            }
            return;
        }
        this._originValue = +value;
        const val = this._adjustValue(+value);
        this._value = val;
        this.oldValue = val;
        this._text.value = val;
    }

    _adjustValue(value) {
        if (!this._isNumeric(value)) {
            return 0;
        }
        if (value % 1 !== 0) {
            const symLength = this._maxdecimalplaces;
            let roundedVal = Number(value).toFixed(symLength);
            if (symLength) {
                roundedVal = roundedVal.replace(/\.*0+$/, "");
            }
            value = Number(roundedVal);
        }
        return value;
    }

    _decimalCount(value) {
        const valStr = value.toString();
        if (valStr.includes(".")) {
            return valStr.split('.').pop().length
        }

        if (valStr.includes(",")) {
            return valStr.split(',').pop().length
        }

        return 0;
    }

    /**
     * Максимальное количество знаков после запятой
     * @type {number}
     */
    get maxdecimalplaces() {
        return this._maxdecimalplaces;
    }
    set maxdecimalplaces(value) {
        const tmp = Number(value);
        if (!isNaN(tmp)) {
            this._maxdecimalplaces = tmp;
            const originValue = this._originValue;
            this.SetParameter(
                "value",
                this._adjustValue(this._originValue ?? this._value),
                true,
                null,
                null,
                "",
                {
                    forced: true,
                }
            );
            this._originValue = originValue;
        }
    }

    set height(value) {
        super.height = value;
    }
    set width(value) {
        super.width = value;
    }

    _calc() {
        if (this._width && this._height) {
            const w = this._width * 0.25;
            const value = this._height < w ? this._height : w;
            this._decr.style.minWidth = `${value}px`;
            this._incr.style.minWidth = `${value}px`;
        }
    }

    get incrementstep() {
        return this._incrementstep;
    }
    set incrementstep(value) {
        const tmp = Number(value);
        if (!isNaN(tmp)) {
            this._incrementstep = tmp;
        }
    }

    get isreadonly() {
        return typeof this._isreadonly === "boolean" ? this._isreadonly : false;
    }
    set isreadonly(value) {
        this._isreadonly = this._toBool(value);
    }

    get showbuttons() {
        return typeof this._showbuttons === "boolean"
            ? this._showbuttons
            : true;
    }
    set showbuttons(value) {
        this._showbuttons = this._toBool(value);
        const s = this._showbuttons ? "flex" : "none";
        this._decr.style.display = s;
        this._incr.style.display = s;
    }

    // Мгновенное получение значений
    get instantdataretrieval() {
        return this._instantdataretrieval ?? false;
    }
    set instantdataretrieval(value) {
        this._instantdataretrieval = this._toBool(value);
    }

    onInput() {
        if (this.instantdataretrieval && !this._isreadonly) {
            this.updateValue();
        }
    }

    updateValue() {
        const strVal = this._text.value.replace(",", ".");
        const cur = strVal.at(-1) === "." ? strVal : Number(strVal); // Если на конце точка, тогда не нужно приводить к числу, поскольку из-за этого она уберётся
        const callbackData = {
            forced: true,
        };

        if (!isNaN(cur)) {
            const val = this._minValidator(this._maxValidator(cur));
            this.SetParameter(
                "value",
                val,
                false,
                null,
                null,
                "",
                callbackData
            );
            this._text.value = this._adjustValue(val);
        } else {
            if (this.instantdataretrieval) {
                return;
            } else {
                this._text.value = this.oldValue ?? this.value;
            }
        }
    }

    /**
     * Коллбек по изменению атрибутов элемента
     * @see https://w3c.github.io/webcomponents/spec/custom/
     * @param {string} attrName название атрибута
     * @param {*} oldVal старое значение атрибута
     * @param {*} newVal новое значение атрибута
     * @param {{
         *  forced: boolean, // изменять параметр принудительно (даже если новое значение не отличается от старого)
         *  link: boolean, // говорит о том, что параметр пришёл по связи
         *  linkids: string, // список Id окон, через параметры которых прошло значение (для избежания зацикливания)
         * }} [callbackData]
     */
    attributeChangedCallback(attrName, oldVal, newVal, itemIndex, callbackData) {
        this.attributeChangedCallbackInternal(attrName, oldVal, newVal, callbackData, "value");
    }

    resetValueInternal() {
        if (this._rawValue != this.value) {
            this.SetParameter("value", this._rawValue, true);
        }
    }

    disconnectedCallback() {
        this._text.oninput = undefined;
        const mousewheelevt = /Firefox/i.test(navigator.userAgent)
            ? "wheel"
            : "mousewheel";
        this.removeEventListener(mousewheelevt, this._updateWheelBind);
        this._text.removeEventListener('input', this.inputListener);
        this._text.removeEventListener('focus', this.focusAndClickHandler);
        this._text.removeEventListener('click', this.focusAndClickHandler);
        this._text.removeEventListener('keydown', this._keydownHandler);
        super.disconnectedCallback();
    }

    _setInputFilter(textbox) {
        textbox.oninput = e => {
            e.preventDefault();
            if (this._isreadonly) {
                textbox.value = this.oldValue;
                return;
            }
            this.oldSelectionStart = textbox.selectionStart;
            this.oldSelectionEnd = textbox.selectionEnd;
            if (
                /^-?\d*[.,]?\d*$/.test(textbox.value) &&
                this._decimalCount(textbox.value) <= this._maxdecimalplaces
            ) {
                if (textbox.value !== "-" && textbox.value !== "-." && textbox.value !== "") {
                    this.oldValue = textbox.value;
                }
                this._text.value = textbox.value;
            } else if (this.hasOwnProperty("oldValue")) {
                textbox.value = this.oldValue;
                textbox.setSelectionRange(
                    this.oldSelectionStart,
                    this.oldSelectionEnd
                );
            }
        };
    }
}